import React from 'react'
import { Path, Rect } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TaskIcon = createIcon({
    viewBox: '0 0 40 40',
    path: (
        <>
            <Rect x='0.5' y='0.5' rx='19.5' stroke='currentColor' />
            <Path
                d='M25.8333 13.4H22.35C22 12.443 21.0833 11.75 20 11.75C18.9167 11.75 18 12.443 17.65 13.4H14.1667C13.25 13.4 12.5 14.1425 12.5 15.05V26.6C12.5 27.5075 13.25 28.25 14.1667 28.25H25.8333C26.75 28.25 27.5 27.5075 27.5 26.6V15.05C27.5 14.1425 26.75 13.4 25.8333 13.4ZM20 13.4C20.4583 13.4 20.8333 13.7713 20.8333 14.225C20.8333 14.6788 20.4583 15.05 20 15.05C19.5417 15.05 19.1667 14.6788 19.1667 14.225C19.1667 13.7713 19.5417 13.4 20 13.4ZM21.6667 24.95H15.8333V23.3H21.6667V24.95ZM24.1667 21.65H15.8333V20H24.1667V21.65ZM24.1667 18.35H15.8333V16.7H24.1667V18.35Z'
                fill='currentColor'
            />
        </>
    ),
})

TaskIcon.displayName = 'TaskIcon'
